<template>
    <root-layout :moduleCode="moduleCode">
        <div class="h-100">
            <header-nav v-if="!$route.meta.hideHeader" :moduleCode="moduleCode">
                <template v-slot:others-menu>
                    <slot name="header-menu"></slot>
                </template>
            </header-nav>

            <panel-right ref="panelRight" v-if="!$route.meta.hideHeader">

                <template v-slot:panel-section-user>
                    <slot name="panel-section-user"></slot>
                </template>

                <template v-slot:others-panels>
                    <slot name="panel-right-sections"></slot>
                </template>

            </panel-right>

            <slot name="main"></slot>

            <div class="modal modal-terms" tabindex="-1" role="dialog">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Política de Privacidade</h5>
                        </div>
                        <div class="modal-body">
                            <p>Veja a nossa politica de privacidade e proteção de dados pessoais e concorde para prosseguirmos</p>
                        </div>
                        <div class="modal-footer">
                            <a href="/pages/terms.html" target="_blank" class="btn btn-primary text-white">Aceder Politica</a>
                            <button type="button" class="btn btn-secondary" @click="agreeTerms">Concordar e Prosseguir</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </root-layout>
</template>

<script>

    import HeaderNav from '@/app/shared/components/header/HeaderNav.vue'
    import PanelRight from '@/elements/PanelRight.vue'

    export default
    {
        props:{
            moduleCode: {
                type: String,
                require: true,
                default: null
            },
            subModuleCode: {
                type: String,
                require: false,
                default: null
            },
        },
        components: {
            'panel-right' : PanelRight,
            'header-nav' : HeaderNav,
        },
        mounted() {
            // if(this.$root.$helper.cookie.getCookie('agreeTerms') == null)
            // {
            //     $('.modal-terms').modal({backdrop: 'static', keyboard: false})  ;
            // }
        },
        methods: {
            agreeTerms: function()
            {
                this.$root.$helper.cookie.setCookie("agreeTerms", true, 365);
                $('.modal-terms').modal('hide')  ;
            }
        }
    }
</script>